module.exports = "/_next/static/images/star-light-e200d4fd.png";